module.exports = __webpack_public_path__ + "static/img/RWA964_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWA964_1.png
// module id = H8q9
// module chunks = 0